module.exports = __webpack_public_path__ + "img/5.2aaf05bd.png";